import Transactions from 'views/Transactions/FinanceTransactions.jsx';
// @material-ui/icons
import DashboardIcon from '@material-ui/icons/Dashboard';
import { LocalShipping } from '@material-ui/icons';
import Truckers from 'views/Truckers/Truckers.jsx';

const financePayableDashRoutes = [
  {
    path: '/finance-payable/transactions',
    name: 'Transactions',
    icon: DashboardIcon,
    component: Transactions,
  },
  {
    path: '/finance-payable/truckers',
    name: 'View Truckers',
    icon: LocalShipping,
    component: Truckers,
  },
];
export default financePayableDashRoutes;
